// Leesona M50 Wax Winder
import React from "react";
import { CommonRows, InputRangeRow, MinMaxRow, RunTimeRow, WindingTensionRow } from "./index";

export default function MachineLeesonaM50Wax() {
   return (
      <>
         <InputRangeRow
            titleProp={"Clock Setting"}
            descriptionProp={"m"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={999999} //some default value
            propertyNameProp={"clockSet"}
            errorDialogueProp={"0-999,999"}
            floatProp={false}
         />
         <RunTimeRow />
         <WindingTensionRow windingTension />
         <MinMaxRow
            titleProp={"Back Press"}
            descriptionProp="kg"
            minProp1={0.00}
            maxProp1={10.00}
            floatProp1={true}
            errorProp1={"0.00-10.00 only"}
            minProp2={0.00}
            maxProp2={10.00}
            floatProp2={true}
            errorProp2={"0.00-10.00 only"}
            valueProp1={"backPressMin"}
            valueProp2={"backPressMax"}
         />
         <InputRangeRow
            titleProp={"Counter Scale Factor"}
            descriptionProp={""}
            sizeProp={4}
            typeProp={"text"}
            minProp={0.0}
            maxProp={999999} //some default value
            propertyNameProp={"scaleFactor"}
            errorDialogueProp={"Cannot be left empty"}
            floatProp={true}
            readOnlyProp={true}
         />
         <CommonRows />
      </>
   );
}
